import { useState } from 'react'
import { Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@cutilei/ui'
import Tooltip from 'components/Tooltip'

import {
  Container,
  Row,
  Column,
  SubTitle,
  InfoText,
  Button,
  AccessLevelBlock
} from './styles'

export default function ImportPermissionsModal ({
  visible,
  accessLevels = [],
  onConfirm: handleConfirm,
  onClose: handleClose
}) {
  const [selectedAccessLevel, setSelectedAccessLevel] = useState (null)

  const handleImport = async () => {
    if (!selectedAccessLevel) return

    handleConfirm (selectedAccessLevel.permissions)
    handleClose ()
  }

  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      <DialogContent size='md' closeOnOutsideClick={false} aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Importar permissões</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Container>
            <InfoText>
              Selecione o nível de acesso do qual deseja importar as permissões.
            </InfoText>
            <Column>
              {accessLevels.map ((accessLevel, index) => (
                <AccessLevelBlock
                  key={index}
                  selected={selectedAccessLevel?.id === accessLevel.id}
                  onClick={() => setSelectedAccessLevel (accessLevel)}
                  style={{margin: 0}}
                >
                  <SubTitle>
                    {accessLevel.name}
                  </SubTitle>
                  <Row>
                    <Tooltip
                      id={accessLevel.id}
                      message={accessLevel.description}
                      labelStyle={{width: 300}}
                      place='bottom'
                    />
                    <InfoText>
                      {accessLevel.permissions.length}
                      {accessLevel.permissions.length === 1 ? ' Permissão' : ' Permissões'}
                    </InfoText>
                  </Row>
                </AccessLevelBlock>
              ))}
            </Column>
          </Container>
        </DialogBody>
        <DialogFooter>
          <Row>
            <Button type='submit' onClick={handleImport}>
              Confirmar
            </Button> 
          </Row>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
